import { useToast, ContextMenuSub, ContextMenuSubContent, ContextMenuSubTrigger } from '@cad-arc';
import {
    ActionTypeEnum,
    UnitContextMenuClickParams,
    UnitTimerResource,
    UnitTimerSubmenuView,
} from '@mark43/cad-api';
import { useCallback } from 'react';
import { useApiClient, createApiErrorHandler } from '@m43/core';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function UnitTimerSubmenu({
    unitTimerSubmenuView,
    clickParams,
}: {
    unitTimerSubmenuView: UnitTimerSubmenuView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const apiClient = useApiClient();
    const modalControls = useFullscreenModalControls();
    const toast = useToast();

    const resetTimer = useCallback(() => {
        return apiClient.request<UnitTimerResource.Update2>({
            method: 'POST',
            url: 'unit_timer/',
            data: {
                actionType: ActionTypeEnum.RESET_UNIT_TIMER.name,
                unitId: clickParams.unitId,
                agencyEventId: clickParams.eventId,
            },
        });
    }, [apiClient, clickParams]);

    const clearTimer = useCallback(() => {
        return apiClient.request<UnitTimerResource.Update2>({
            method: 'POST',
            url: 'unit_timer/',
            data: {
                actionType: ActionTypeEnum.CLEAR_UNIT_TIMER.name,
                unitId: clickParams.unitId,
                agencyEventId: clickParams.eventId,
            },
        });
    }, [apiClient, clickParams]);

    return unitTimerSubmenuView.isVisible ? (
        <ContextMenuSub>
            <ContextMenuSubTrigger
                data-pendo-id="menu-item-unit-timer"
                isDisabled={!unitTimerSubmenuView.isEnabled}
            >
                {unitTimerSubmenuView.label}
            </ContextMenuSubTrigger>
            {unitTimerSubmenuView.resetTimerContextMenuItemView &&
                unitTimerSubmenuView.resetTimerToContextMenuItemView &&
                unitTimerSubmenuView.clearTimerContextMenuItemView && (
                    <ContextMenuSubContent>
                        <ContextMenuItem
                            contextMenuItemView={unitTimerSubmenuView.resetTimerContextMenuItemView}
                            onSelect={() =>
                                resetTimer().catch(
                                    createApiErrorHandler(() => {
                                        toast({
                                            status: 'error',
                                            description: errorOccurredWhile('resetting timer'),
                                        });
                                    })
                                )
                            }
                        />
                        <ContextMenuItem
                            contextMenuItemView={
                                unitTimerSubmenuView.resetTimerToContextMenuItemView
                            }
                            onSelect={() => {
                                modalControls.open({
                                    type: 'UNIT_TIMERS_RESET_TO',
                                    props: { unitId: clickParams.unitId },
                                });
                            }}
                        />
                        <ContextMenuItem
                            contextMenuItemView={unitTimerSubmenuView.clearTimerContextMenuItemView}
                            onSelect={() =>
                                clearTimer().catch(
                                    createApiErrorHandler(() => {
                                        toast({
                                            status: 'error',
                                            description: errorOccurredWhile('clearing timer'),
                                        });
                                    })
                                )
                            }
                        />
                    </ContextMenuSubContent>
                )}
        </ContextMenuSub>
    ) : (
        <></>
    );
}
